<template>
  <div>
    <el-table
      :data="result"
      :fit="true"
      width=500px
      class="table-header-th-top-0"
    >

      <!-- 施設名 -->
      <el-table-column
        class-name="col-3"
        prop="meetingRoomName"
        :label="$t('label.system.meetingRoom.create.meetingRoomName')"
      />

      <!-- ビル名 -->
      <el-table-column
        prop="buildingName"
        :label="$t('label.system.openMeetingRoomSetting.create.buildingName')"
        class-name="col-3"
      />

      <!-- フロア名 -->
      <el-table-column
        prop="floorName"
        :label="$t('label.system.openMeetingRoomSetting.create.floorName')"
        class-name="col-3"
      />

      <!-- エリア名 -->
      <el-table-column
        prop="areaName"
        :label="$t('label.system.building.detail.areaName')"
        class-name="col-3"
      />
      <!-- 利用可能ポイント -->
      <el-table-column
        prop="pointList"
        :label="$t('label.system.openMeetingRoomSetting.create.availablePoints')"
        class-name="col-4">
        <template slot-scope="scope">
          <div v-for="(val, index) in scope.row.pointList" :key="index">
            <div>{{val.pointName + "\n"}}</div>
          </div>
        </template>
      </el-table-column>

      <!-- ポイント -->
      <el-table-column
        prop="unitPrice"
        :label="$t('label.point.common.point')"
        class-name="col-2"
      >
        <template slot-scope="scope">
          {{ scope.row.unitPrice }} pt / 15分
        </template>
      </el-table-column>

      <!-- 金額(税抜)
      <el-table-column
        prop="exTaxAmount"
        label="金額(税抜)"
        class-name="col-2"
      >
        <template slot-scope="scope">
          {{ scope.row.exTaxAmount }} 円 / 15分
        </template>
      </el-table-column> -->

    </el-table>
  </div>
</template>

<script>
import SpSmartButton from "@/components/common/sp-smart-button"

export default {
  name: "MeetingRoomSearchList",
  data() {
    return {SpSmartButton};
  },
  props: {
    result: Array,
  },
};
</script>

<style scoped>
.color {
  color: #525250;
  font-size: 16px;
}
::v-deep .el-table__header {
  height: 20px;
}
::v-deep .el-table th,
.el-table td {
  padding: 3px 0;
}
::v-deep .cell {
  font-size: 12px;
  line-height: 14px;
}
::v-deep .el-table th > .cell {
  padding-left: 8px;
  padding-right: 0;
}
::v-deep .el-table .cell {
  font-size: 12px;
}
::v-deep .el-table th > .cell {
  font-size: 12px !important;
}
::v-deep .el-table thead tr th,
::v-deep .el-table__empty-block,
::v-deep .el-table__body-wrapper {
 background-color: #F7F7F2 !important;
}
</style>
